module.exports = __webpack_public_path__ + "img/premium_feature_01.c8a6288b.jpg";